// src/pages/healthcare/appointments/components/BlockMoveConfirm.tsx
import React from "react";
import { Alert, Modal, Typography } from "antd";

import { ConflictingAppointment } from "../../../../api/healthcare/Appointment/AppointmentApi";
import { formatLocalTime } from "../../../../utils/userPrefs/DateTimeUtils";

interface BlockMoveConfirmProps {
	conflicts: ConflictingAppointment[];
	checkFailed: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

// Moving a block onto appointments is as significant as creating it there, so it reuses S11's warning verbatim.
const BlockMoveConfirm: React.FC<BlockMoveConfirmProps> = ({ conflicts, checkFailed, onConfirm, onCancel }) => (
	<Modal
		open
		title="Move this block?"
		okText="Move it anyway"
		okButtonProps={{ "data-testid": "appointments-block-move-confirm" } as never}
		cancelButtonProps={{ "data-testid": "appointments-block-move-cancel" } as never}
		onOk={onConfirm}
		onCancel={onCancel}
		width={480}
	>
		{checkFailed ? (
			<Alert
				type="warning"
				showIcon
				data-testid="appointments-block-move-check-failed"
				message="Existing appointments could not be checked"
				description="Move it anyway — any appointments in this time are not cancelled or moved."
			/>
		) : (
			<Alert
				type="warning"
				showIcon
				data-testid="appointments-block-move-conflicts"
				message={`${conflicts.length} appointment${conflicts.length === 1 ? "" : "s"} already booked in this time`}
				description={
					<>
						<ul style={{ margin: "4px 0 8px", paddingLeft: 18 }}>
							{conflicts.map((conflict) => (
								<li key={conflict.id}>
									{formatLocalTime(conflict.start)} – {formatLocalTime(conflict.end)} · {conflict.patient}
								</li>
							))}
						</ul>
						<Typography.Text strong>These appointments are not cancelled or moved.</Typography.Text>
					</>
				}
			/>
		)}
	</Modal>
);

export default BlockMoveConfirm;
